import type { InteractionResponse } from "../../FpPages/RMS/Dashboard/types";

/** A related meeting owns these note bytes only through primary, history or copy resolution. */
export const isInteractionNoteSource = (
  interaction: InteractionResponse,
  blobId: string
): boolean => {
  if ("blob_resolution" in interaction) {
    return (
      interaction.blob_resolution === "primary" ||
      interaction.blob_resolution === "historical" ||
      interaction.blob_resolution === "copy"
    );
  }
  // Older cached primary responses remain safe. A differing document needs
  // explicit provenance; attachment and history used to share the same flag.
  return interaction.document_id === blobId;
};
